import { render, staticRenderFns } from "./NewActivityEditor.vue?vue&type=template&id=21ad0dc8&scoped=true&"
import script from "./NewActivityEditor.vue?vue&type=script&lang=js&"
export * from "./NewActivityEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewActivityEditor.vue?vue&type=style&index=0&id=21ad0dc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad0dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ad0dc8')) {
      api.createRecord('21ad0dc8', component.options)
    } else {
      api.reload('21ad0dc8', component.options)
    }
    module.hot.accept("./NewActivityEditor.vue?vue&type=template&id=21ad0dc8&scoped=true&", function () {
      api.rerender('21ad0dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewActivityEditor.vue"
export default component.exports